import { env } from '@/env';
import { newsScritturaConsentita } from '@/lib/newsScrittura';

/**
 * La regola di `lib/newsScrittura.ts` applicata a QUESTA build: `MODE` e `VITE_NEWS_API_URL` (senza default) sono le due costanti
 * che Vite sostituisce in build. Si valuta a ogni chiamata e non a livello di modulo, di proposito: un test deve poterle cambiare
 * senza ricaricare l'app.
 */
export function newsScritturaOra(): boolean {
  return newsScritturaConsentita(import.meta.env.MODE, env.newsDestinationUrl);
}
